import { FormControl, styled } from '@mui/material'
import { getModalStyle } from '../../../../../utils'

export const StyledModalContainer = styled('div')(({ theme }) => ({
  ...getModalStyle(),
  position: 'absolute',
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[5],
  [theme.breakpoints.up('sm')]: {
    maxWidth: theme.spacing(64),
  },
  [theme.breakpoints.down('xs')]: {
    maxWidth: 'calc(100% - 32px)',
  },
}))

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  width: '100%',
  margin: theme.spacing(0, 0, 2.5, 0),
  '& .MuiAutocomplete-root': {
    margin: theme.spacing(0, 0, 2.5, 0),
  },
}))
